const notificationPreferencesType = {
    EMAIL : 'EMAIL',

    POPUP : 'POPUP'

};

angular.module('gw-um-j2js')
    .constant('notificationPreferencesType', notificationPreferencesType);